import { useEffect, useState } from 'react';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4themes_animated from '@amcharts/amcharts4/themes/animated';
import { Skeleton } from '@mui/material';
import { Stack } from '@mui/material';

am4core.useTheme(am4themes_animated);

const TrendLinesChart = ({ data, chartTypePercentage }) => {
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    setShowLoader(true);

    if (data?.values.length) {
      let chart = am4core.create('trendLinesDiv', am4charts.XYChart);
      chart.events.on('ready', () => {
        setShowLoader(false);
      });

      // Enable chart cursor
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.lineX.disabled = true;
      chart.cursor.lineY.disabled = true;

      // Enable scrollbar
      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarY = new am4core.Scrollbar();

      // Add data
      chart.data = data.values;

      chart.legend = new am4charts.Legend();
      chart.legend.position = 'bottom';
      chart.legend.itemContainers.template.paddingTop = 3;
      chart.legend.itemContainers.template.paddingBottom = 3;
      chart.legend.scrollable = true;
      chart.legend.maxHeight = 100;

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.DateAxis());
      categoryAxis.renderer.grid.template.location = 0.5;
      categoryAxis.dateFormatter.inputDateFormat = 'yyyy';
      categoryAxis.renderer.minGridDistance = 40;
      categoryAxis.tooltipDateFormat = 'yyyy';

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

      valueAxis.formatLabel = function (value) {
        if (data.percentage) {
          return (value)+'%';
        } else {
          let locale = window.localStorage.getItem('locale') ? window.localStorage.getItem('locale') : 'sq';

          let billionShortForm = locale === 'en' ? ' B ALL' : ' MLD ALL',
              millionShortForm = locale === 'en' ? ' M ALL' : ' MLN ALL',
              thousandShortForm = locale === 'en' ? ' K ALL' : ' MIJE ALL';

          if(value >= 1000000000) {
            return (value/1000000000).toString()+billionShortForm;
          } else if(value >= 1000000) {
            return (value/1000000).toString()+millionShortForm;
          } else if(value >= 1000) {
            return (value/1000).toString()+thousandShortForm;
          } else {
            return (value)+' ALL';
          }
        }
      }

      function createTrendLine(name, lines) {
        let trend = chart.series.push(new am4charts.LineSeries());
        trend.name = name;
        trend.dataFields.valueY = 'value';
        trend.dataFields.dateX = 'period';
        trend.strokeWidth = 2;
        trend.data = lines;

        let bullet = trend.bullets.push(new am4charts.CircleBullet());
        bullet.tooltipText = `${name}\n{period} - [bold font-size: 17px]{valueY}[/]${data.percentage ? '%' : ''}`;
        bullet.strokeWidth = 2;
        bullet.stroke = am4core.color('#fff');
        bullet.circle.fill = trend.stroke;

        let hoverState = bullet.states.create('hover');
        hoverState.properties.scale = 1.7;

        return trend;
      }

      data.values.forEach((el) => {
        createTrendLine(el.name, el.lines);
      });

      chart.exporting.menu = new am4core.ExportMenu();
      chart.exporting.menu.align = 'left';
      chart.exporting.menu.verticalAlign = 'top';
      // chart.exporting.menu.useDataFields = false;

      chart.exporting.adapter.add('data', function(data) {
        
        const newData = [];
        data.data.forEach((el) => {
          newData.push({ name: el.name });
          el.lines.forEach((line) => {
            const newObj = {};

            Object.keys(line).forEach((prop) => {
              newObj[prop] = line[prop];
            });

            newData.push(newObj);
          });
        });
        data.data = newData;
        return data;
      });
    }
  }, [data]);

  return (
    <>
      <div id='trendLinesDiv' style={{ width: showLoader ? '0' : '100%', height: showLoader ? '0' : `700px` }}></div>
      {showLoader && (
        <Stack spacing={1}>
          <Skeleton variant='text' sx={{ fontSize: '1rem' }} />
          <Skeleton variant='rounded' width={'auto'} height={500} />
        </Stack>
      )}
    </>
  );
};

export default TrendLinesChart;
